// extracted by mini-css-extract-plugin
export default {"card":"UserActivity_card__ifSlV","cardTitle":"UserActivity_cardTitle__Z6HdI","questionList":"UserActivity_questionList__CKnMM","appear":"UserActivity_appear__b9+Hl"};